import { render, staticRenderFns } from "./Estadistica.vue?vue&type=template&id=4b651cb2&scoped=true"
import script from "./Estadistica.vue?vue&type=script&lang=js"
export * from "./Estadistica.vue?vue&type=script&lang=js"
import style0 from "./Estadistica.vue?vue&type=style&index=0&id=4b651cb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b651cb2",
  null
  
)

export default component.exports